export default "__VITE_ASSET__COxgVvC4__"